import { render, staticRenderFns } from "./AnimatedLogo.vue?vue&type=template&id=7c3621fb&"
import script from "./AnimatedLogo.vue?vue&type=script&lang=js&"
export * from "./AnimatedLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports